export default __webpack_public_path__ + "static/415-01232ad40d27d722658d273cd80dcd31.gif";